export default __webpack_public_path__ + "static/media/vector-services.6e35c4fd.png";